<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានអតិថិជន</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* តម្រូវឱ្យបំពេញ</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>ឈ្មោះអតិថិជន *</label>
							<md-input type="text" v-model="client.name"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>កំណត់សំគាល់</label>
							<md-input type="text" v-model="client.description">
							</md-input>
						</md-field>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានសង្ខេប</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 50%;">ឈ្មោះអតិថិជន</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.name).length > 0">{{client.name}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.phone).length > 0">{{client.phone}} (មិនអាចផ្លាស់ប្តូរ)</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>កំណត់សំគាល់</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.description).length > 0">{{client.description}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="updateClient()">កែប្រែ</md-button>
			</div>
		</div>
	</div>

	<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getClient();
		},

		data() {
			return {
				loaded: false,
				client: {
					id: "",
					name: "",
					phone: "",
					description: ""
				}
			}
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + '/admin/client/get/' + this.$route.params.hash_id).then(data => {
					this.client.id = data.body.data.id
					this.client.name = data.body.data.name
					this.client.phone = data.body.data.phone
					this.client.description = data.body.data.note
					this.loaded = true
				})
			},
			updateClient() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/update", {
					client: this.client
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "ព័ត៌មានត្រូវបានកែប្រែដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
					}
					this.$router.push("/clients");

				})
			},
			checkValidation() {
				if (String(this.client.name).length > 0 && String(this.name_khmer).length > 0 && String(this.client.phone).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.client = {
					id: "",
					name: "",
					phone: "",
					description: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Referral/Edit.vue